import React, { useState } from 'react';
import '../../styles/site/HowToUseSection.css';

const HowToUseSection = ({ title, subtitle, iosSteps, androidSteps }) => {
  const [activeTab, setActiveTab] = useState('ios');

  return (
    <section className="how-to-use-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{title}</h2>
          <p className="section-subtitle">{subtitle}</p>
          <div className="divider">
            <span className="star-divider">✧</span>
          </div>
        </div>

        <div className="installation-guides">
          <div className="platform-tabs">
            <button 
              className={`tab-button ${activeTab === 'ios' ? 'active' : ''}`}
              onClick={() => setActiveTab('ios')}
            >
              <i className="fab fa-apple"></i> iPhone (iOS)
            </button>
            <button 
              className={`tab-button ${activeTab === 'android' ? 'active' : ''}`}
              onClick={() => setActiveTab('android')}
            >
              <i className="fab fa-android"></i> Android
            </button>
          </div>

          <div className="installation-content">
            <div className={`tab-content ${activeTab === 'ios' ? 'active' : ''}`}>
              <div className="steps-container">
                <div className="steps-image">
                  <img src="/images/site/iphone.svg" alt="iPhone com ChatGPT" />
                </div>
                
                <div className="steps-list">
                  <h3>Passo a Passo para Instalação:</h3>
                  <ol>
                    {iosSteps.map((step, index) => (
                      <li key={index} className="step-item">
                        <div className="step-number">{index + 1}</div>
                        <div className="step-text">{step}</div>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>

            <div className={`tab-content ${activeTab === 'android' ? 'active' : ''}`}>
              <div className="steps-container">
                <div className="steps-image">
                  <img src="/images/site/android.svg" alt="Android com ChatGPT" />
                </div>
                
                <div className="steps-list">
                  <h3>Passo a Passo para Instalação:</h3>
                  <ol>
                    {androidSteps.map((step, index) => (
                      <li key={index} className="step-item">
                        <div className="step-number">{index + 1}</div>
                        <div className="step-text">{step}</div>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
          </div>
          
          <div className="next-steps">
            <h3>Após a instalação:</h3>
            <p>1. Abra o ChatGPT e crie uma conta se você ainda não tiver</p>
            <p>2. Digite "@roboliviam" para começar a interagir com a Liv_IAm</p>
            <p>3. Pronto! Sua assistente astrológica está à sua disposição 24/7</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToUseSection;